module.exports = __webpack_public_path__ + "img/mickey53.130f55f3.jpg";